/** How a user is named and shown as an avatar, everywhere in the app. */

export const displayName = (user) => [user.first_name, user.last_name].filter(Boolean).join(' ') || user.username;

export const initialsOf = (user) => {
  const first = user.first_name?.trim();
  const last = user.last_name?.trim();
  if (first && last) return `${first[0]}${last[0]}`.toUpperCase();
  return (first || user.username || '?').slice(0, 2).toUpperCase();
};

/** The same initials from a display name ("Ana Lima" -> "AL"), for people the API sends by name only. */
export const initialsOfName = (name) => {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length > 1) return `${words[0][0]}${words[words.length - 1][0]}`.toUpperCase();
  return (words[0] || '?').slice(0, 2).toUpperCase();
};
